import { useCallback } from 'react';

import { buildOneInchTx } from '../../services/swap/buildOneInchTx';
import { UpdateQuoteParams } from '../../services/types';
import { AppDispatch } from '../../store';
import { handleBuildTxError } from '../../utils';
import { TxBuilder } from '../update/types';

export const useBuildOneInchTx = (): TxBuilder => {
  return useCallback(async (params: UpdateQuoteParams, dispatch: AppDispatch) => {
    try {
      return await buildOneInchTx(params);
    } catch (e) {
      handleBuildTxError(e, dispatch);
      throw e;
    }
  }, []);
};
